import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Complete = props => {
    let { paymentData, paymentInfo } = props
    let { success_url, payment_id } = paymentData
    let { depositorypayment_txid } = paymentInfo
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div className="payment__box_right">
            <div className="payment__layout payment__layout_success" />
            <p className="payment__title payment__text-size_m payment__margin-bottom_x">
                {translation['Success']}
            </p>
            <div className="payment__icon payment__icon_success payment__margin-bottom_m">
                <FontAwesomeIcon icon={'check-circle'} />
            </div>
            <p className="payment__desc payment__desc_white payment__desc_align-center payment__margin-bottom_m">
                {translation['The payment is successfully complete']}
            </p>
            <a
                href={`${success_url}depositorypayment_id=${payment_id}&depositorypayment_txid=${depositorypayment_txid}`}
            >
                <button className="payment__button">
                    {translation['Continue']}
                </button>
            </a>
        </div>
    )
}

export default Complete
